<script>
	import { getContext } from 'svelte';
	import {makeSVGpathCurved} from "../../../utils/BezierConverter";

	const { data, xGet, yGet, xScale, yScale, extents } = getContext('LayerCake');
	export let fill = '#F7CCD5';

		$: pathCurved = () => {
		let tempList = [];
		$data[1].values
			.map(d => {
				tempList.push([$xGet(d) , $yGet(d)]);
			})	
			return makeSVGpathCurved(tempList);
	}
	let area;
	$: {
		const yRange = $yScale.range();
		area = pathCurved() + (
			'L' + $xScale($extents.x[1]) + ',' + yRange[0] +
			'L' + $xScale($extents.x[0]) + ',' + yRange[0] +
			'Z'
		);
	}
</script>

<path class='path-area' d='{area}' {fill}></path>

<style>
.path-area {
	fill: rgba(240, 185, 185, 0.6)
}
</style>